import React from "react";

import TotalSkinPresenter from "./TotalSkinPresenter";

export default class extends React.Component {

  render() {
    return <TotalSkinPresenter />;
  }
}
